<!-- <app-header-auth></app-header-auth> -->

<main class="auth-page">
  <section class="auth-card">

    <!-- Header -->

    <header class="auth-card__header">
      <div class="auth-logo">
        M
      </div>

      <span class="auth-eyebrow">
        WELCOME BACK
      </span>

      <h1>
        {{ 'SIGNIN' | translate }}
      </h1>

      <p>
        შედი Menuload-ის მართვის პანელში და გააგრძელე
        შენი რესტორნის მართვა.
      </p>
    </header>


    <!-- Social login -->

    <div class="social-login">

      <button
        type="button"
        class="social-button social-button--google"
        (click)="loginWithGoogle()"
      >
        <!-- <fa-icon [icon]="faGoogle"></fa-icon> -->

        <span>
          Google-ით გაგრძელება
        </span>
      </button>


      <button
        type="button"
        class="social-button social-button--apple"
        (click)="loginWithApple()"
      >
        <!-- <fa-icon [icon]="faApple"></fa-icon> -->

        <span>
          Apple-ით გაგრძელება
        </span>
      </button>


      <button
        type="button"
        class="social-button social-button--microsoft"
        (click)="loginWithMicrosoft()"
      >
        <!-- <fa-icon [icon]="faMicrosoft"></fa-icon> -->

        <span>
          Microsoft-ით გაგრძელება
        </span>
      </button>


      <button
        type="button"
        class="social-button social-button--facebook"
        (click)="loginWithFacebook()"
      >
        <!-- <fa-icon [icon]="faFacebookF"></fa-icon> -->

        <span>
          Facebook-ით გაგრძელება
        </span>
      </button>

    </div>


    <!-- Divider -->

    <div class="auth-divider">
      <span></span>

      <small>
        ან ელფოსტით
      </small>

      <span></span>
    </div>


    <!-- Backend error -->

    <div
      class="auth-error"
      *ngIf="admin.error?.message"
    >
      <i class="fi fi-rr-exclamation"></i>

      <span>
        ელფოსტა ან პაროლი არასწორია.
      </span>
    </div>


    <!-- Login form -->

    <form
      class="auth-form"
      [formGroup]="validateForm"
      (ngSubmit)="submitForm()"
    >

      <!-- Email -->

      <div class="auth-field">
        <label for="user">
          {{ 'EMAIL' | translate }}
        </label>

        <div
          class="auth-input"
          [class.auth-input--invalid]="
            userControl?.invalid &&
            (userControl?.dirty || userControl?.touched)
          "
        >
          <i class="fi fi-rr-envelope"></i>

          <input
            id="user"
            type="email"
            formControlName="user"
            [placeholder]="'EMAIL' | translate"
            autocomplete="email"
          >
        </div>

        <small
          class="field-error"
          *ngIf="
            userControl?.hasError('required') &&
            (userControl?.dirty || userControl?.touched)
          "
        >
          ელფოსტა სავალდებულოა.
        </small>

        <small
          class="field-error"
          *ngIf="
            userControl?.hasError('email') &&
            !userControl?.hasError('required') &&
            (userControl?.dirty || userControl?.touched)
          "
        >
          მიუთითე სწორი ელფოსტა.
        </small>
      </div>


      <!-- Password -->

      <div class="auth-field">
        <div class="auth-field__header">
          <label for="password">
            {{ 'PASSWORD' | translate }}
          </label>

          <a routerLink="/reset/password">
            {{ 'RESETPASS' | translate }}
          </a>
        </div>

        <div
          class="auth-input"
          [class.auth-input--invalid]="
            passwordControl?.invalid &&
            (passwordControl?.dirty || passwordControl?.touched)
          "
        >
          <i class="fi fi-rr-lock"></i>

          <input
            id="password"
            [type]="showPassword ? 'text' : 'password'"
            formControlName="password"
            [placeholder]="'PASSWORD' | translate"
            autocomplete="current-password"
          >

          <button
            type="button"
            class="password-toggle"
            aria-label="Show or hide password"
            (click)="showPassword = !showPassword"
          >
            <i
              [class]="
                showPassword
                  ? 'fi fi-rr-eye-crossed'
                  : 'fi fi-rr-eye'
              "
            ></i>
          </button>
        </div>

        <small
          class="field-error"
          *ngIf="
            passwordControl?.hasError('required') &&
            (passwordControl?.dirty || passwordControl?.touched)
          "
        >
          პაროლი სავალდებულოა.
        </small>
      </div>


      <!-- Remember me -->

      <label class="remember-checkbox">
        <input
          type="checkbox"
          formControlName="remember"
        >

        <span class="remember-checkbox__box">
          <i class="fi fi-rr-check"></i>
        </span>

        <span>
          დამიმახსოვრე
        </span>
      </label>


      <!-- Submit -->

      <button
        type="submit"
        class="auth-submit"
        [disabled]="validateForm.invalid || admin.loading"
      >
        <span
          class="auth-submit__spinner"
          *ngIf="admin.loading"
        ></span>

        <span>
          {{
            admin.loading
              ? 'მიმდინარეობს ავტორიზაცია...'
              : ('SIGNIN' | translate)
          }}
        </span>

        <i
          class="fi fi-rr-arrow-small-right"
          *ngIf="!admin.loading"
        ></i>
      </button>

    </form>


    <!-- Registration -->

    <footer class="auth-card__footer">
      <span>
        {{ 'NO_ACCAUNT' | translate }}?
      </span>

      <a routerLink="/signup">
        {{ 'SIGNUP' | translate }}
      </a>
    </footer>

  </section>


  <!-- Side information -->

  <aside class="auth-side">
  <div class="auth-side__orb auth-side__orb--top"></div>
  <div class="auth-side__orb auth-side__orb--bottom"></div>

  <div class="auth-side__content">

    <div class="auth-side__eyebrow">
      <span class="auth-side__eyebrow-icon">
        <i class="fi fi-rr-sparkles"></i>
      </span>

      <span>MENULOAD FOR RESTAURANTS</span>
    </div>

    <h2>
      მართე შენი
      <strong>რესტორანი</strong>
      ერთი სივრციდან
    </h2>

    <p class="auth-side__description">
      მართე ციფრული მენიუ, შეკვეთები, პროდუქტები და ანალიტიკა
      Menuload-ის ერთიანი პლატფორმიდან.
    </p>

    <div class="auth-feature-list">

      <div class="auth-feature">
        <span class="auth-feature__check">
          <i class="fi fi-rr-check"></i>
        </span>

        <div>
          <strong>ციფრული QR მენიუ</strong>

          <small>
            შექმენი თანამედროვე მენიუ, რომელსაც მომხმარებელი
            ტელეფონიდან მარტივად გახსნის.
          </small>
        </div>
      </div>

      <div class="auth-feature">
        <span class="auth-feature__check">
          <i class="fi fi-rr-check"></i>
        </span>

        <div>
          <strong>ონლაინ შეკვეთები</strong>

          <small>
            მიიღე და მართე შეკვეთები რეალურ დროში
            ერთი სამუშაო სივრციდან.
          </small>
        </div>
      </div>

      <div class="auth-feature">
        <span class="auth-feature__check">
          <i class="fi fi-rr-check"></i>
        </span>

        <div>
          <strong>შენი საკუთარი მისამართი</strong>

          <small>
            მიიღე უნიკალური მისამართი:
            restaurant.menuload.com
          </small>
        </div>
      </div>

    </div>

    <div class="auth-trust-card">
      <span class="auth-trust-card__icon">
        <i class="fi fi-rr-shield-check"></i>
      </span>

      <div>
        <strong>უსაფრთხო ავტორიზაცია</strong>

        <small>
          შენი მონაცემები დაცულია უსაფრთხო ავტორიზაციით.
        </small>
      </div>
    </div>

  </div>
</aside>

</main>